import type { OrderId, StoreId } from 'shared/domain';
import { transformToAnalyticsParams } from 'shared/infra/analytics';
import Amplitude from 'tools/amplitude/amplitude';

export interface LogStoreAudit {
  orderId: OrderId;
  storeId: StoreId;
  isMandatory: boolean;
  allChecked?: boolean;
}

function log(params: LogStoreAudit) {
  const transformedParams = transformToAnalyticsParams(params);
  Amplitude.logEvent('STORE_AUDIT_DEFECTS', transformedParams);
}

export const storeAuditAnalytics = {
  log,
};
